import { render, staticRenderFns } from "./DialogWrapperDesktop.vue?vue&type=template&id=2ddbc046&"
import script from "./DialogWrapperDesktop.vue?vue&type=script&lang=ts&"
export * from "./DialogWrapperDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./DialogWrapperDesktop.vue?vue&type=style&index=0&id=2ddbc046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports